module.exports = __webpack_public_path__ + "img/sence_asi_4.ed10c431.png";